<template>
  <div class="container">
    <el-dialog
      :title="activityReviewId == '' ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="activitiesDialog"
      @close="dialogClose"
    >
      <el-form
        ref="activitiesRef"
        :model="activitiesReviewObj"
        label-width="100px"
        @keyup.enter.native="newsSubmit()"
        :rules="formRules"
      >
        <el-form-item label="名称搜索" prop="activitiesReviewObj">
          <!-- <el-input
                        v-model="activitiesReviewObj.title"
                        placeholder="请输入活动总览名称"
                        @change="sda(activitiesReviewObj.title)"
                    > -->
          <el-select
            v-model="activitiesReviewObj.id"
            width="100"
            filterable
            clearable
            remote
            :remote-method="remoteMethod"
            :loading="loading"
            placeholder="请选择活动总览"
          >
            <el-option
              v-for="item in newsAboutActivity"
              :key="item.id"
              :label="showcontent(item.title)"
              :value="item.id"
            >
            </el-option>
            <!-- </el-input> -->
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="活动时间" prop="startTime">
          <el-date-picker
            v-model="activitiesStartTime"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="newsSubmit">提交</el-button>
          <el-button @click="activitiesDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { showcontent } from "../../utils/method";
export default {
  data() {
    return {
      body: {
        limit: 10,
        page: 1,
        title: "",
      },
      loading: false,
      activitiesDialog: false, //控制对话框的显示
      activitiesReview: [], //活动总览
      activityId: null, //活动id
      activityReviewId: "", //活动总览id
      activitiesReviewObj: {
        title: "",
        id: "",
      }, //活动总览相关对象
      activitiesStartTime: "", //活动开始时间
      newsAboutActivity: [], //和活动相关的新闻
      newsId: "",
      formRules: {
        activitiesReviewObj: [
          { message: "请输入活动总览名称", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    showcontent,
    init(activityId, activityReviewId = "") {
      this.activitiesDialog = true;
      this.$nextTick(() => {
        this.$refs.activitiesRef.resetFields();
      });
      this.activityId = activityId;
      this.activityReviewId = activityReviewId;
      this.getNewsById(); //获取新闻
    },
    //获取活动总览
    async getActivityiesReview() {
      let { data } = await this.$ajaxGet(
        `/activitiesPreview/listActivitiesPreview?id=${this.$route.params.id}`
      );
      console.log(data, "活动总览");
      if (data.code === 0) {
        this.activitiesReview = data.data;
      }
    },
     handle(value){
            console.log(value,'事件')
            // this.newsId = item.id
            this.activitiesReviewObj.activitiesTopic = value
        }, 
    //提交表单
    newsSubmit() {
      console.log(this.activitiesReviewObj.id);
      this.$refs.activitiesRef.validate((valid) => {
        if (valid) {
          console.log(valid);
          this.$ajaxGet(
            `/activities/${
              this.activityReviewId === ""
                ? "/addExcitingNewsToActivityId"
                : "updateActivitiesPreview"
            }`,
            {
              // activitiesTopic: this.activitiesReviewObj.title,
              // activitiesStartTime: this.activitiesStartTime,
              newsId: this.activitiesReviewObj.id,
              activityId:
                this.activityId === "" ? null : parseInt(this.activityId),
              // newsId:this.newsId,
              // id:
              //   this.activityReviewId === ""
              //     ? null
              //     : parseInt(this.activityReviewId),
            }
          ).then(({ data }) => {
            console.log("新增或修改", data);
            if (data.code === 0) {
              this.activitiesDialog = false;
              this.$emit("activitiesReviewUpdated");
            } else {
              this.$message.error(
                `${this.activityReviewId === "" ? "新增" : "修改"}失败！`
              );
            }
          });
        } else {
          return false;
        }
      });
    },
    remoteMethod(val) {
      if (val) {
        this.loading = true;
        this.$ajaxPost(`/news/list`, {
          limit: 10,
          page: 1,
          title: val,
        }).then((res) => {
            this.loading = false
          console.log(res);
          this.newsAboutActivity = res.data.data.list;
        });
      }

      console.log(val);
    },
    //通过活动id查询新闻
    async getNewsById() {
      let { data } = await this.$ajaxPost(`/news/list`, this.body);
      console.log(data, "查询新闻");
      if (data.data.list) {
        this.newsAboutActivity = data.data.list;
      } else {
      }
      //   if (data.data.records[0] == null) {
      //     this.newsAboutActivity = [];
      //   } else {

      //   }
      // this.newsAboutActivity = data.data.records || []
    },
    //关闭弹窗时触发
    dialogClose() {
      console.log(12);
      this.activitiesReviewObj = [];
    },
    /* beforeClose(){
            console.log(1)
            this.$refs.activitiesRef.resetFields()
        } */
  },
};
</script>

<style>
</style>